import { LosslessNumber, isLosslessNumber, isSafeNumber, parse, stringify } from "lossless-json"

export { isLosslessNumber }

/**
 * Cell responses carry exact numbers (#2770: decimals and large integers are
 * exact JSON numbers). Numbers a double represents exactly become plain
 * numbers; every other number stays a `LosslessNumber` with its source digits,
 * so nothing the console shows or sends is silently rounded.
 */
function parseNumber(text: string): number | LosslessNumber {
  return isSafeNumber(text) ? Number(text) : new LosslessNumber(text)
}

export function parseExact(text: string): unknown {
  return parse(text, null, parseNumber)
}

/** JSON text with exact numbers, optionally indented. */
export function stringifyExact(value: unknown, indent?: number): string {
  return stringify(value, undefined, indent) ?? "null"
}

/** A value for display: exact digits for preserved numbers, plain text otherwise. */
export function exactText(value: unknown): string | undefined {
  return isLosslessNumber(value) ? value.value : undefined
}
